import { Component, OnInit, ViewChild } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';


@Component({
  selector: 'app-lista-adjudicaciones',
  templateUrl: './lista-adjudicaciones.component.html',
  styleUrls: ['./lista-adjudicaciones.component.scss'],
})
export class ListaAdjudicacionesComponent implements OnInit {
  displayedColumns: string[] = ['Subasta', 'Lote', 'Especie', 'Precio', 'Cantidad', 'Importe'];
  dataAdjudica: any;
  dataSource;
  subasta;
  cliente;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(navParams: NavParams, public modalCtrl: ModalController, public apiService: ApiService) {
    // this.dataAdjudica = navParams.get('adjudica');
    this.cliente = navParams.get('cliente');
    this.apiService.getAdjudicaciones(this.cliente).subscribe((data: any) => {
      this.dataAdjudica = data;

      this.subasta = navParams.get('subasta');
      if (this.dataAdjudica) {
        if (this.dataAdjudica.length > 0) {
          //this.dataSource = new MatTableDataSource(navParams.get('adjudica'));
          this.dataSource = new MatTableDataSource(this.dataAdjudica);
        }
      }
    });
    console.log('ADJUDICA MODAL::', this.dataAdjudica);
  }

  formatPrecio(precioUnidad) {
    return Number.parseFloat(precioUnidad).toFixed(2).replace(".", ",");
  }

  formatImporte(precioUnidad, cantidad) {
    return (Number.parseFloat(precioUnidad) * Number.parseFloat(cantidad)).toFixed(2).replace(".", ",");
  }

  getTotalesCantidad() {
    var totalCantidad = 0.0;
    for (let x in this.dataAdjudica) {
      let cantidad = this.dataAdjudica[x].cantidad;
      totalCantidad += Number.parseFloat(cantidad);
    }
    return totalCantidad.toFixed(2).replace(".", ",");
  }

  getTotalesImporte() {
    var totalImporte = 0.0;
    for (let x in this.dataAdjudica) {
      let cantidad = this.dataAdjudica[x].cantidad;
      let precio = this.dataAdjudica[x].precio;
      totalImporte += (Number.parseFloat(cantidad) * Number.parseFloat(precio));
    }
    return totalImporte.toFixed(2).replace(".", ",");
  }

  ngOnInit() {
    if (this.dataSource) { this.dataSource.sort = this.sort; }
  }

  public dismissModal() {
    this.modalCtrl.dismiss({
      dismissed: true
    });
  }

}
